export const NAMED_ELEMENT_SAVE_CONFLICT = 'NAMED_ELEMENT_SAVE_CONFLICT';
export const NAMED_ELEMENT_SAVE_SUCCESS = 'NAMED_ELEMENT_SAVE_SUCCESS';
export const NAMED_ELEMENT_SAVE_FAILURE = 'NAMED_ELEMENT_SAVE_FAILURE';
export const NAMED_ELEMENT_ARCHIVE_SUCCESS = 'NAMED_ELEMENT_ARCHIVE_SUCCESS';
export const NAMED_ELEMENT_ARCHIVE_FAILURE = 'NAMED_ELEMENT_ARCHIVE_FAILURE';
export const NAMED_ELEMENT_UNARCHIVE_SUCCESS = 'NAMED_ELEMENT_UNARCHIVE_SUCCESS';
export const NAMED_ELEMENT_UNARCHIVE_FAILURE = 'NAMED_ELEMENT_UNARCHIVE_FAILURE';
export const CLOSED = 'CLOSED';

// The attribute used to store the schema of the properties attached to a given element in the DOM.
export const FsPropertiesSchemaAttribute = 'data-fs-properties-schema';
// The legacy attribute used to store the schema of the properties attached to a giben element in the DOM.
export const FsLegacyPropertiesSchemaAttribute = 'data-fs-element-properties';

export const FsPropertiesSchemaAttributes = [
  FsPropertiesSchemaAttribute,
  FsLegacyPropertiesSchemaAttribute,
];
